module.exports = __webpack_public_path__ + "static/media/AU-BUV-210004_Buvidal-Patient-Alert-Card.c2273e3f.pdf";